import styled, { css } from 'styled-components';
import Icon from '@klv/atoms/icon';

export const DesktopTopicsMenu = styled.div`
  display: none;
  max-width: 38rem;
  width: 100%;
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      display: block;
    }
  `}
`;

export const MobileTopicsMenu = styled.div`
  color: ${({ theme }) => theme.topicsMenu.default.color};
  position: relative;

  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      display: none;
    }
  `}
`;

const selectStyles = css`
  background-color: #fff;
  color: ${({ theme }) => theme.topicsMenu.default.color};
`;

export const MobileTopicsMenuInput = styled.select`
  appearance: none;
  border: 1px solid ${({ theme }) => theme.topicsMenu.default.mobileInputBorder};
  border-radius: 0.6rem;
  display: block;
  font-size: 1.6rem;
  line-height: 2.4rem;
  outline: none;
  padding: 0.6rem 3.2rem 0.6rem 1.2rem;
  width: 100%;

  ${selectStyles}

  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      display: none;
    }
  `}

  option {
    max-width: 100%;
    width: 100%;
  }
`;

export const MobileTopicsMenuItem = styled.option`
  ${selectStyles}
`;

export const SelectArrow = styled(Icon)`
  pointer-events: none;
  position: absolute;
  right: 1.4rem;
  top: 50%;
  transform: translateY(-50%);
  user-select: none;
`;
